import { DynamicObjectInterface } from '../../../sdk/type';
import { FAIcon, Tag, TagStyle, Theme } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { dateTimeToCustomFormat } from '../../../ui/utils';

type IProductBO = {
  [key: string]: DynamicObjectInterface;
};

const getCampaignListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'campaignId',
    text: translation('admin.campaignConfig.campaignId'),
    width: 4,
    sortable: true,
    render: (object: IProductBO) => <span>{object.campaignId}</span>,
  },
  {
    key: 'campaignName',
    text: translation('admin.campaignConfig.campaignName'),
    sortable: true,
    width: 8,
    render: (object: IProductBO) => <span>{object.campaignName}</span>,
  },
  {
    key: 'campaignType',
    text: translation('admin.campaignConfig.campaignType'),
    sortable: true,
    width: 8,
    render: (object: IProductBO) => <span>{object.campaignType}</span>,
  },
  {
    key: 'status',
    text: translation('admin.campaignConfig.status'),
    sortable: true,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.status === 'ONGOING' ? Theme.SUCCESS : object.status === 'NEW' ? Theme.WARNING : Theme.ERROR}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
    key: 'campaignStart',
    text: translation('admin.campaignConfig.startDate'),
    width: 4,
    sortable: true,
    render: (object: IProductBO) => <span>{dateTimeToCustomFormat(object.campaignStart, 'DD/MM/yyyy')}</span>,
  },
  {
    key: 'campaignEnd',
    text: translation('admin.campaignConfig.endDate'),
    sortable: true,
    width: 4,
    render: (object: IProductBO) => <span>{dateTimeToCustomFormat(object.campaignEnd, 'DD/MM/yyyy')}</span>,
  },

  {
    key: 'actions',
    width: 1,
    text: translation('admin.userSetup.actions'),
    render: (object: IProductBO) => (
      <>
        <FAIcon
          onMouseOver={() => {}}
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onClick(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export default getCampaignListConfig;
